import { computed, getCurrentInstance } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import providers from "@/lib/api";
import { AppSessionStorage } from "@/lib/appStorage";
import { STORAGE } from "@/const";
import { OnboardingNames, OnboardingStatus } from "./const";
import { OnboardingData } from "./types";

const filterData = (data: OnboardingData, status: OnboardingStatus) => {
  const filteredData: OnboardingData = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value === status) {
      filteredData[key] = value;
    }
  });
  return filteredData;
};

export default function useOnboarding(name: OnboardingNames) {
  const vm = getCurrentInstance();
  const { authUser, authUserStrict } = useAuthUser();

  const onboardingData = computed<StateRoot["onboarding"]>(() => (vm ? vm.$store.state.onboarding : null));
  const show = computed(() => !!authUser.value && !onboardingData.value?.[name]);

  const update = (status: OnboardingStatus) => {
    const data = {
      ...onboardingData.value,
      [name]: status,
    };
    vm?.$store.commit(MUTATION_TYPES.SET_ONBOARDING, data);

    if (status === OnboardingStatus.HIDDEN) {
      AppSessionStorage.setObject(STORAGE.ONBOARDING, filterData(data, OnboardingStatus.HIDDEN));
    } else if (status === OnboardingStatus.COMPLETED) {
      providers.UserFrontendData.update({
        data: {
          userId: authUserStrict.value.id,
          onboarding: filterData(data, OnboardingStatus.COMPLETED),
        },
      });
    }
  };

  const hide = () => {
    update(OnboardingStatus.HIDDEN);
  };

  const complete = () => {
    update(OnboardingStatus.COMPLETED);
  };

  return {
    onboardingData,
    show,
    update,
    hide,
    complete,
  };
}
